/* eslint-disable react/prop-types */
import * as React from "react";

export const SvgSuccessFill = ({ color = "#0F9E60", ...props }) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.998.4a9.6 9.6 0 1 0 9.6 9.6 9.61 9.61 0 0 0-9.6-9.6Zm4.573 7.919-5.416 5.17a.74.74 0 0 1-1.021 0l-2.708-2.585a.739.739 0 0 1 1.021-1.07l2.197 2.099L13.55 7.25a.74.74 0 0 1 1.022 1.069Z"
			fill={color}
		/>
	</svg>
);
